import React from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { FeatureService } from "../services/FeatureService"
import { useZuAbschlag } from "./hooks/ZuAbschlag"
import { RechnungNachlassView } from "./RechnungNachlassView"
import { useStoreRechnung } from "../store"

export function RechnungNachlaesseView() {
    const { rechnungAbschlaege } = useStoreRechnung("rechnungAbschlaege")

    const { add, remove, onChange } = useZuAbschlag(rechnungAbschlaege, "rechnungAbschlaege")
    const { t } = useTranslation()
    const disabled = FeatureService.isFeatureActive("DEMO")

    return (
        <Components.Collapsible title={t("rechnung.rechnungAbschlaege.title")} collapsed={true}>
            {rechnungAbschlaege.map((a, idx) => (
                <RechnungNachlassView key={idx} index={idx} abschlag={a} onRemove={remove} onChange={onChange} />
            ))}

            <Components.Row>
                <Components.Col align={Components.Align.RIGHT}>
                    <Components.Button
                        style={Components.ButtonStyle.SECONDARY}
                        label={t("rechnung.rechnungAbschlaege.hinzufuegen")}
                        onClick={add}
                        disabled={disabled}
                        tooltip={disabled ? t("demoversion.nicht.aktiv.hinweis") : ""}
                        tooltipAtDisabled={disabled}
                    />
                </Components.Col>
            </Components.Row>
        </Components.Collapsible>
    )
}
